export function assertLog(condition: boolean, message?: string, state?: object) {
  if (!condition) {
    console.error(format('[Assert fail]' + message, state))
  }
}

export function log(message: string, options: JsonLogOptions) {
  console.log(format(message, options))
}

export function logError(message: string, obj?: object) {
  console.error(format(message, obj))
}

function jsonStringify(options: JsonLogOptions) {
  const { state, pretty } = options
  return pretty ? JSON.stringify(state, null, 2) : JSON.stringify(state)
}

interface JsonLogOptions {
  state?: object
  pretty?: boolean
}
export function logJson(obj: object, options: JsonLogOptions = {}) {
  options.state = obj
  console.log(jsonStringify(options))
}

function format(message?: string, options: JsonLogOptions = {}): string {
  const { state } = options
  message = '' + message
  if (!state) {
    return message
  }

  const formattedState = jsonStringify(options)
  return `${message}: ${formattedState}`
}

export function getTimeStr(): string {
  return new Date().toLocaleTimeString()
}
